import React from "react";

// ICONS
import headerIcon from "../../../static/img/img-ihr-by-bodymatter-hr-logo-black-sm@3x.png";

// STYLES
import "./OopsAlreadyPremium.scss";

const OopsAlreadyPremium: React.FC = () => {
    return (
        <div className="OopsAlreadyPremium">
            <div className="OopsAlreadyPremium__content">
                <img
                    src={headerIcon}
                    loading="lazy"
                    alt="Instant Heart Rate"
                    className="OopsAlreadyPremium__logo"
                />
                <h4 className="OopsAlreadyPremium__title">Oops!</h4>
                <p className="OopsAlreadyPremium__message">
                    It looks like your account is already Premium.
                </p>

                <button
                    className="OopsAlreadyPremium__button"
                    type="button"
                    onClick={() => {
                        const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
                        if (url) {
                            window.location.assign(url);
                        } else {
                            console.error(
                                "Missing REACT_APP_UNIVERSAL_DEEP_LINK",
                            );
                        }
                    }}
                >
                    Open Instant Heart Rate
                </button>
            </div>
        </div>
    );
};

export default OopsAlreadyPremium;
